import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/lit/node_modules/@lit/reactive-element/reactive-element.js';
import { html as x } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as n } from '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/property.js';
import '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { renderInteractiveElement } from '../../atoms/generic-elements/interactive-element/index.js';
import { ButtonStyleTypes, ButtonTypes, ButtonSizes } from '../../atoms/buttons/enums.js';
import css_248z$1 from '../../atoms/buttons/generic-button/styles/primary-button.scss.js';
import css_248z from './load-more-button.scss.js';

class LoadMoreButton extends s {
    render() {
        return x `<div class="load-more"><generic-button .onClick="${this.onClickHandler}" styleType="${ButtonStyleTypes.OUTLINED_DARK}" type="primary-button">${renderInteractiveElement({
            mainClass: 'primary-button',
            isAnchor: false,
            type: ButtonTypes.SUBMIT,
            text: this.text,
            style: ButtonStyleTypes.OUTLINED_DARK,
            size: ButtonSizes.REGULAR,
            mobileInverted: false,
            mobileWhite: false,
            disabled: false,
            rtl: false,
        })}</generic-button></div>`;
    }
}
LoadMoreButton.styles = [css_248z, css_248z$1];
__decorate([
    n({ type: String })
], LoadMoreButton.prototype, "text", void 0);
__decorate([
    n({ type: Function })
], LoadMoreButton.prototype, "onClickHandler", void 0);
customElements.define('load-more-button', LoadMoreButton);

export { LoadMoreButton };
